module.exports = __webpack_public_path__ + "media/images/favicon/safari-pinned-tab-f0e3585f235d4fe03f94cfdf601234e7.svg";